const BEFORE = 'BEFORE'
const AFTER = 'AFTER'
const CHILD = 'LAST_CHILD'
const NOP = 'NOP'

export default { BEFORE, AFTER, CHILD, NOP }
